<template>
  <div class="d-grid custom-grid" :title="titleText">
    <span :class="indicator.class" v-if="!indicator.enabled">{{indicator.symbol}}</span>
    <span class="grid-end-x value">{{ valueToDraw }}</span>
    <span class="tooltiptext">{{ tooltipText }}</span>
  </div>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import i18n from '@core/plugins/i18n';

@Component
export default class PriceManager extends Vue {
  @Prop({ type: String, required: true, default: null }) prop;

  @Prop({ type: Object, required: true, default: null }) model;

  originalPrice = 0.0;

  get valueToDraw() {
    return this.model[this.prop] ? `${this.model[this.prop]}€` : '?';
  }

  get tooltipText() {
    return i18n.t('priceCellOutOfRange');
  }

  get titleText() {
    const previousPrice = this.model[`${this.prop}_prev`];
    const message = `${previousPrice}€ -> ${this.model[this.prop]}€`;
    return previousPrice !== this.model[this.prop] ? message : null;
  }

  get indicator() {
    const priceDiff = this.model[this.prop] - this.model[`${this.prop}_prev`];
    if (priceDiff > 0) return { symbol: '▲', class: 'up-sign' };
    if (priceDiff < 0) return { symbol: '▼', class: 'down-sign' };
    if (priceDiff === 0) return { symbol: '=', class: 'equal-sign' };
    return { symbol: ' ', disabled: true };
  }

  mounted() {
    this.originalPrice = this.model[this.prop];
  }
}

</script>

<style scoped>
.custom-grid {
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 0 0;
  position: relative;
}
.equal-sign {
  padding-left: 3px;
  padding-right: 3px;
  font-weight: bold;
  color: blue;
}
.up-sign {
  color: green;
}
.down-sign {
  color: red;
}
.tooltiptext {
  box-shadow: inset 0px 0px 50px 50px #ff5e5e;
  text-align: center;
  border-radius: 6px;
  opacity: 0;
  /* Position the tooltip */
  position: absolute;
  left: -10px;
  transition: 0.3s;
  z-index: -1;
}
.error-cell:hover .tooltiptext {
  opacity: 1;
  transition: 0.5s;
  z-index: 1;
}
</style>
